import { isBefore, startOf } from '@lingoda/dates';
import { ClassType } from '@lingoda/monolith-graphql';

export type LeadTimeBannerFacts = {
    isStudentEligibleToSeeBanner: boolean;
    classType: ClassType;
    filterDates: Date[];
    firstDateBeyondLeadTime: Date | undefined;
};

export const shouldShowLeadTimeBanner = (facts: LeadTimeBannerFacts): boolean => {
    return (
        facts.isStudentEligibleToSeeBanner &&
        facts.classType === ClassType.Group &&
        isSearchingInsideLeadTime(facts)
    );
};

const isSearchingInsideLeadTime = ({
    filterDates,
    firstDateBeyondLeadTime,
}: LeadTimeBannerFacts) => {
    if (!firstDateBeyondLeadTime) {
        return false;
    }

    const firstDayBeyondLeadTime = startOf('day', firstDateBeyondLeadTime);

    return (
        filterDates.length === 0 ||
        filterDates.some((date) => isBefore(startOf('day', date), firstDayBeyondLeadTime))
    );
};
